import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useId } from 'react';

import { FabricCuratedSelectionBasedFilterTranslation } from '../../localization/SiteTranslation';
import { ToggleButtonGroup, ToggleButtonGroupItem } from '../../shared/components/ToggleButtonGroup/ToggleButtonGroup';
import { FabricCuratedSelectionBasedFilterState } from '../FabricCuratedSelectionBasedFilterState';
import css from './FabricCuratedSelectionBasedFilter.css';

interface FabricCuratedSelectionBasedFilterProps {
  state: FabricCuratedSelectionBasedFilterState;
  translation: FabricCuratedSelectionBasedFilterTranslation;
}

const FabricCuratedSelectionBasedFilter = ({ state, translation }: FabricCuratedSelectionBasedFilterProps) => {
  const descriptionId = useId();

  if (state.curatedSelections.length === 0) {
    return null;
  }

  return (
    <div className={css.root}>
      <ToggleButtonGroup
        aria-label={translation.label}
        aria-describedby={state.selected.description ? descriptionId : undefined}
        selectedItemId={state.selected.id}
        onSelectionChange={state.selectById}
      >
        {state.curatedSelections.map((x) => (
          <ToggleButtonGroupItem id={x.id} key={x.id}>
            {x.name}
            {x.isNew && (
              <span className={classNames(css.badge, { [css.selected]: x.id === state.selected.id })}>
                {translation.newText}
              </span>
            )}
          </ToggleButtonGroupItem>
        ))}
      </ToggleButtonGroup>
      {state.selected.description && (
        <div id={descriptionId} className={css.description}>
          {state.selected.description}
        </div>
      )}
    </div>
  );
};

export default observer(FabricCuratedSelectionBasedFilter);
